type ToggleProps = {
	value: boolean
	setValue: (newValue: boolean) => void
	label: string
}

export function Toggle(props: ToggleProps) {
	return (
		<button
			onClick={(e) => {
				e.preventDefault()
				props.setValue(!props.value)
			}}
		>
			{props.value ? "Hide" : "Show"} {props.label}
		</button>
	)
}
